<template>
    <div class="flex gap-3 mb-[20px]">
        <label
            class="flex items-center gap-2 px-2.5 py-1.5 rounded-full border-[1px]  cursor-pointer transition-all duration-200"
            :class="selected === 'credit' ? 'bg-customYellow-100 text-white !border-customYellow-100' : 'border-[#ccc] bg-[#EFEFEF] text-[#333333]'">
            <input type="radio" name="payment" value="credit" v-model="selected"
                class="appearance-none w-5 h-5 !border-2 border-[#ccc] bg-[#fff] rounded-full relative checked:border-white checked:w-5 checked:h-5 checked:!border-4 checked:!bg-transparent" />
            <span class="text-[14px] font-regular font-poppins contents">Credit Card</span>
        </label>
        <!-- <label
            class="flex items-center gap-2 px-3 py-2 rounded-full border-[1px]  cursor-pointer transition-all duration-200"
            :class="selected === 'bank' ? 'bg-[#BA90C6] text-white border-[#BA90C6]' : 'border-[#ccc] bg-[#EFEFEF] text-[#333333]'">
            <input type="radio" name="payment" value="bank" v-model="selected"
                class="appearance-none w-5 h-5 !border-2 border-[#ccc] bg-[#fff] rounded-full relative checked:border-white checked:w-5 checked:h-5 checked:!border-4 checked:!bg-transparent" />
            <span class="text-[14px] font-regular font-poppins contents">Bank Account</span>
        </label> -->
    </div>
    <div v-if="selected === 'credit'" class="flex flex-col gap-[15px]">
        <div class="flex flex-col gap-[3px]">
            <label class="text-[14px] font-normal font-poppins text-[#666666] w-full" for="cardholder">Cardholder
                Name<span class="ml-1 text-red-500">*</span></label>
            <inputComponent ref="cardHolderName" name="cardholder" required placeholder="Full name on card" length="120"
                v-model="cardHolderName" error-message="Invalid Cardholder Name"
                customClass="!text-[16px] font-poppins font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]" />
        </div>
        <div class="flex flex-col gap-[3px]">
            <label class="text-[14px] font-normal font-poppins text-[#666666] w-full" for="cardnumber">Card
                Number<span class="ml-1 text-red-500">*</span></label>
            <div class="relative">
                <div id="card-number" class="min-h-[38px] py-[10px] px-3 rounded-lg border border-[#cccccc]">
                </div>
                <div id="card-number-error" class=""></div>
            </div>
        </div>
        <div class="grid grid-cols-2 gap-[30px]">
            <div class="flex flex-col gap-[3px]">
                <label class="text-[14px] font-normal font-poppins text-[#666666] w-full" for="cardexpiry">Expiry<span
                        class="ml-1 text-red-500">*</span></label>
                <div class="relative">
                    <div id="card-expiry" class="min-h-[38px] py-[10px] px-3 rounded-lg border border-[#cccccc]">
                    </div>
                    <div id="card-expiry-error" class=""></div>
                </div>
            </div>
            <div class="flex flex-col gap-[3px]">
                <label class="text-[14px] font-normal font-poppins text-[#666666] w-full" for="cardCVC">CVC<span
                        class="ml-1 text-red-500">*</span></label>
                <div class="relative">
                    <div id="card-cvc" class="min-h-[38px] py-[10px] px-3 rounded-lg border border-[#cccccc]">
                    </div>
                    <div id="card-cvc-error" class=""></div>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="flex flex-col gap-[15px]">
        <div class="flex flex-col gap-[3px]">
            <label class="text-[14px] font-normal font-poppins text-[#666666] w-full" for="cardholder">Account
                Title<span class="ml-1 text-red-500">*</span></label>
            <inputComponent ref="" name="cardholder" required placeholder="Enter Account Title" length="120"
                v-model="accountTitle" error-message="Invalid Account Title"
                customClass="!text-[16px] font-poppins font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]" />
        </div>
        <div class="flex flex-col gap-[3px]">
            <label class="text-[14px] font-normal font-poppins text-[#666666] w-full" for="cardholder">Routing
                Number<span class="ml-1 text-red-500">*</span></label>
            <inputComponent ref="" name="cardholder" required placeholder="Enter Routing Number" length="120"
                v-model="rountingNumber" error-message="Invalid Routing Number"
                customClass="!text-[16px] font-poppins font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]" />
        </div>
        <div class="flex flex-col gap-[3px]">
            <label class="text-[14px] font-normal font-poppins text-[#666666] w-full" for="cardholder">Account Type<span
                    class="ml-1 text-red-500">*</span></label>
            <inputComponent ref="" name="cardholder" required placeholder="Enter Account Type" length="120"
                v-model="accountType" error-message="Invalid Account Type"
                customClass="!text-[16px] font-poppins font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]" />
        </div>
        <div class="flex flex-col gap-[3px]">
            <label class="text-[14px] font-normal font-poppins text-[#666666] w-full" for="cardholder">Account
                Number<span class="ml-1 text-red-500">*</span></label>
            <inputComponent ref="" name="cardholder" required placeholder="Enter Account Number" length="120"
                v-model="accountNumber" error-message="Invalid Account Number"
                customClass="!text-[16px] font-poppins font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]" />
        </div>
    </div>
    <div class="flex flex-col gap-[15px] mt-[20px]">
        <div>
            <label
                class="relative flex items-start gap-2 cursor-pointer select-none text-[14px] font-medium text-[#666666] ">
                <input type="checkbox" v-model="checkboxes.terms" class="mt-[3px] appearance-none min-w-[30px] min-h-[30px] w-[30px] h-[30px] border-[1px] border-[#ccc] rounded-[5px] relative
              checked:border-customBlue-100 transition-colors duration-200
             flex items-center justify-center" />
                <span class="text-[13px] font-poppins font-normal text-[#666666] ">By checking this box, I request
                    enrollment in the protection plan and confirm that I have read and understand the <button type="button" @click="openTermsModal"
                        class="text-customBlue-100 focus:outline-none underline">
                        Terms and
                        Conditions</button>, including coverage limits and exclusions.
                </span>
                <!-- Checkmark -->
                <div class="absolute top-[3px] left-0 w-[30px] h-[30px] flex items-center justify-center">
                    <svg v-if="checkboxes.terms" class="w-[20px] h-[20px]  text-customBlue-100 pointer-events-none"
                        fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                </div>
            </label>
        </div>

        <div class="w-full py-[15px] border-t border-[#EFEFEF]">
            <div class="flex items-center justify-between w-full pb-1.5">
                <label for="consumersignature"
                    class="text-[14px] font-normal font-poppins text-[#666666] w-full">Customer
                    Signature<span class="ml-1 text-[#F5B134]">*</span></label>
                <button type="button" @click="clearSignature" :disabled="!isSignatureValid" class="transform lg:hover:-translate-y-1 lg:hover:scale-[1.02] lg:disabled:hover:-translate-y-0 lg:hover:disabled:scale-100 active:translate-y-0 active:scale-[0.98] duration-300 group text-[14px] mobile:w-[24px] mobile:h-[24px] laptop:w-[75px] h-[24px] flex justify-center items-center gap-1.5 transition-all rounded-full border-[1px] border-[#F5B134] bg-[#F5B134]
                        disabled:hover:!bg-[#EFEFEF]  disabled:bg-[#EFEFEF] disabled:border-[#EFEFEF]">
                    <span
                        class="mobile:hidden laptop:flex group-hover:text-white text-[#fff] group-disabled:text-[#999999] group-disabled:hover:text-[#999999]">
                        Clear
                    </span>
                    <img src="../../../assets/images/razer-white-icon.svg" alt="razer icon"
                        class="w-[14px] h-[14px] object-contain group-disabled:hidden">
                    <img src="../../../assets/images/razer-icon.png" alt="razer icon"
                        class="w-[14px] h-[14px] object-contain filter hidden group-disabled:block group-disabled:invert-[60%] group-disabled:brightness-0">
                </button>
            </div>
            <div class="w-full h-[120px] laptop:h-[120px] pb-2.5">
                <VueSignaturePad height="100%" width="100%" ref="signaturePad" :options="{
                    onBegin: onBegin,
                    onEnd: onEnd
                }"
                    class="!text-base font-medium border border-[#cccccc] outline-none py-2 px-3 w-full rounded-lg placeholder:text-[#cccccc] text-#666666 resize-none" />
            </div>
        </div>
    </div>
    <div class="flex justify-center">
        <button :disabled="!validationCheck"
            class="group CustomBlueBtn flex items-center gap-[12px] px-[20px] py-[8px] text-[16px] font-poppins rounded-full transition duration-300 border-[1px] border-customBlue-100 mobile:text-white laptop:bg-customBlue-100 laptop:hover:bg-gradient-to-r laptop:from-[#2459A8] laptop:to-[#117EC2] mobile:bg-customBlue-100 laptop:text-white laptop:hover:text-[#fff] disabled:hover:!bg-gradient-to-r disabled:hover:from-transparent disabled:hover:to-transparent disabled:hover:cursor-not-allowed disabled:hover:text-[#CCCCCC] disabled:bg-transparent disabled:text-[#CCCCCC] disabled:border-[#CCCCCC]"
            @click="submitForm">
            <span>Confirm Purchase </span>
            <div class="group-disabled:filter group-disabled:invert group-disabled:brightness-[0.25]">
                <img src="../../../assets/images/arrow-white-icon.svg" alt="Arrow Icon" class="w-[16px] h-[16px] ">
            </div>
        </button>
    </div>
    <TermsAndConditionsModal ref="termsModal" />
</template>
<script>
import { globals } from "../../../main";
import inputComponent from '../../partialComponent/inputComponent.vue';
import TermsAndConditionsModal from './terms_and_conditions_modal.vue';
import { useToast } from "vue-toastification";
const toast = useToast();
export default {

    components: {
        inputComponent,
        TermsAndConditionsModal
    },
    props: ["stripe_id"],
    data() {
        return {
            selected: "credit",
            accountTitle: null,
            rountingNumber: null,
            accountType: null,
            accountNumber: null,
            checkboxes: {
                terms: false,
            },
            isValid: false,
            isSignatureValid: false,
            signationImageFile: null,
            saveSignatureTimeout: null,
            token: null,
            cardNumber: null,
            cardExpiry: null,
            cardCvc: null,
            cardHolderName: null,
            cardNumberError: null,
            cardExpiryError: null,
            cardCvcError: null,
            cardNumberValid: false,
            cardExpiryValid: false,
            cardCvcValid: false,
            cardBrand: null
        }
    },

    computed: {

        stripeElements() {
            return this.$stripe.elements({
                fonts: [
                    {
                        cssSrc: "https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap",
                    },
                ],
            });
        },

        validationCheck() {
            if (this.$helper.isEmpty(this.cardHolderName)) return false;
            if (!this.cardNumberValid) return false
            if (!this.cardExpiryValid) return false
            if (!this.cardCvcValid) return false
            if (!this.checkboxes.terms) return false
            if (!this.isSignatureValid) return false
            return true;
        },
    },

    watch: {
        'stripe_id': {
            handler(value) {
                if (this.stripe_id) {
                    setTimeout(() => {
                        this.create()
                    }, 50);
                }
            },
            immediate: true,
        },

    },

    mounted() {

    },

    methods: {
        reset() {
            this.isValid = false
            this.isSignatureValid = false
            this.signationImageFile = null
            this.saveSignatureTimeout = null
            this.token = null
            this.cardHolderName = null
            this.cardNumberError = ''
            this.cardExpiryError = ''
            this.cardCvcError = ''
            this.cardNumberValid = false
            this.cardExpiryValid = false
            this.cardCvcValid = false
            this.cardBrand = ''
            this.checkboxes = {
                terms: false,
            }
            document.getElementById('card-number-error').innerHTML = ''
            document.getElementById('card-expiry-error').innerHTML = ''
            document.getElementById('card-cvc-error').innerHTML = ''
            this.destroy()
            this.create()
            this.clearSignature()
            if (this.$refs.cardHolderName) {
                this.$refs.cardHolderName.resetField()
            }

        },

        create() {
            globals.$loader.show();
            const style = {
                base: {
                    color: 'black',
                    fontFamily: '"Lato", sans-serif',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#ccccd1',
                    },
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a',
                },
            };

            console.log("STRIP", this.$stripe)

            if (this.$stripe == null) {

                // this.$stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY, {
                //     stripeAccount: this.stripe_id + ""
                // })
                this.$stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY)

            }
            this.cardNumber = this.stripeElements.create('cardNumber', {
                style,
                disableLink: true,
            });

            this.cardNumber.mount('#card-number');
            this.cardExpiry = this.stripeElements.create('cardExpiry', { style });
            this.cardExpiry.mount('#card-expiry');
            this.cardCvc = this.stripeElements.create('cardCvc', { style });
            this.cardCvc.mount('#card-cvc');

            this.cardNumber.on("change", (event) => {

                // brand detect
                this.cardBrand = event.brand && event.brand !== "unknown"
                    ? (event.brand == 'visa' ? 'card-icon-1'
                        : event.brand == 'mastercard' ? 'card-icon-2'
                            : event.brand == 'amex' ? 'card-icon-3'
                                : null) : null;

                if (event.error) {
                    this.cardNumberValid = false
                    this.cardNumberError = event.error.message
                } else if (!event.complete) {
                    this.cardNumberValid = false
                    this.cardNumberError = "Card number is incomplete"
                } else {
                    this.cardNumberValid = true
                    this.cardNumberError = null
                }
                this.displayError(event, "card-number-error")
            })

            this.cardExpiry.on("change", (event) => {
                if (event.error) {
                    this.cardExpiryValid = false
                    this.cardExpiryError = event.error.message
                } else if (!event.complete) {
                    this.cardExpiryValid = false
                    this.cardExpiryError = "Card number is incomplete"
                } else {
                    this.cardExpiryValid = true
                    this.cardExpiryError = null
                }
                this.displayError(event, "card-expiry-error")
            })

            this.cardCvc.on("change", (event) => {
                if (event.error) {
                    this.cardCvcValid = false
                    this.cardCvcError = event.error.message
                } else if (!event.complete) {
                    this.cardCvcValid = false
                    this.cardCvcError = "Card number is incomplete"
                } else {
                    this.cardCvcValid = true
                    this.cardCvcError = null
                }
                this.displayError(event, "card-cvc-error")
            })

            globals.$loader.hide();
        },

        displayError(event, elementId) {
            let errorContainer = document.getElementById(elementId);
            if (event.error) {

                errorContainer.innerHTML = `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">${event.error.message}</p>`
                if (elementId === "card-number-error") this.cardNumberError = event.error.message;
                if (elementId === "card-expiry-error") this.cardExpiryError = event.error.message;
                if (elementId === "card-cvc-error") this.cardCvcError = event.error.message;
            } else {
                errorContainer.innerHTML = ''
                if (elementId === "card-number-error") this.cardNumberError = null;
                if (elementId === "card-expiry-error") this.cardExpiryError = null;
                if (elementId === "card-cvc-error") this.cardCvcError = null;
            }
        },

        destroy() {

            if (this.cardNumber) {
                this.cardNumber.destroy();
            }

            if (this.cardExpiry) {
                this.cardExpiry.destroy();
            }

            if (this.cardCvc) {
                this.cardCvc.destroy();

            }
        },

        checkValidation() {
            let isValid = true;

            const refsToValidate = [
                this.$refs.cardHolderName,
            ];
            let firstInvalidRef = null;
            // Validate each ref
            for (const ref of refsToValidate) {
                if (ref?.validate?.()) {
                    if (!firstInvalidRef) firstInvalidRef = ref;
                }
            }
            // Cardholder Name
            if (firstInvalidRef) {
                isValid = false;
            }
            // Stripe elements errors
            if (this.cardNumberError) {
                document.getElementById('card-number-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">${this.cardNumberError}</p>`;
                isValid = false;
            }
            if (this.cardExpiryError) {
                document.getElementById('card-expiry-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">${this.cardExpiryError}</p>`;
                isValid = false;
            }
            if (this.cardCvcError) {
                document.getElementById('card-cvc-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">${this.cardCvcError}</p>`;
                isValid = false;
            }
            if (!this.cardNumberError && !this.cardNumber._complete) {
                document.getElementById('card-number-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">Card number field is required</p>`;
                isValid = false;
            }
            if (!this.cardExpiryError && !this.cardExpiry._complete) {
                document.getElementById('card-expiry-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">Expiry date field is required</p>`;
                isValid = false;
            }
            if (!this.cardCvcError && !this.cardCvc._complete) {
                document.getElementById('card-cvc-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">CVC field is required</p>`;
                isValid = false;
            }

            return isValid;
        },

        async getData() {
            const { token, error } = await this.$stripe.createToken(this.cardNumber)
            return { token, error }
        },

        onBegin() {
            //this.isSignatureValid = false
            this.$refs.signaturePad.resizeCanvas();
            if (this.saveSignatureTimeout) {
                clearTimeout(this.saveSignatureTimeout);
            }
        },

        onEnd() {
            if (this.saveSignatureTimeout) {
                clearTimeout(this.saveSignatureTimeout);
            }
            this.saveSignatureTimeout = setTimeout(() => {
                this.saveSignature();
                this.saveSignatureTimeout = null;
                
            }, 500);
        },

        async saveSignature() {
            let result = { isEmpty: true, data: null }
            if (this.$refs.signaturePad) result = this.$refs.signaturePad.saveSignature();
            // console.log("Out Signature");

            if (!result.isEmpty) {

                this.signationImageFile = await this.base64ToFile(result.data, "signature.png");
                this.isSignatureValid = true

                // console.log("In Signature",this.signationImageFile);

            }
        },

        base64ToFile(base64String, filename) {
            const arr = base64String.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },

        getSignature() {
            return this.signationImageFile
        },

        clearSignature() {
            this.$refs.signaturePad.clearSignature()
            this.isSignatureValid = false
            this.signationImageFile = null
            this.saveSignatureTimeout = null
        },

        async submitForm() {

            if (this.checkValidation()) {
                globals.$loader.show();
                let payload = await this.getData()
                if (payload.error) {
                    globals.$loader.hide();
                    toast.error(payload?.error?.message ?? 'Invalid Signature');
                    return
                }
                if (this.saveSignatureTimeout) {
                    clearTimeout(this.saveSignatureTimeout);
                    this.saveSignatureTimeout = null;
                }

                if (!this.signationImageFile) {
                    await this.saveSignature();
                }

                let signatureFile = this.getSignature()
                if (!signatureFile) {
                    globals.$loader.hide();
                    toast.error('Signature is required.');
                    return
                }

                globals.$loader.hide();
                let formData = {
                    card_token: payload.token.id,
                    card_holder_name: this.cardHolderName,
                    signature_image: signatureFile
                }
                this.$emit('submitDetail', formData);
            }
        },

        openTermsModal() {
            if (this.$refs.termsModal) {
                this.$refs.termsModal.open();
            }
        }

    },

}
</script>